module.exports = __webpack_public_path__ + "static/img/wemos_d1_mini-1.9a25471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/wemos_d1_mini-1.svg
// module id = nYZ0
// module chunks = 0